/**
 * @description
 * Objeto xmlfields
 */

import { Fieldtypes } from "./fieldtypes.model";
import { Xmldefs } from "./xmldefs.model";

export class Xmlfields {
    public id:number = null;
    public code:string = "";
    public desc:string;
    //public fieldtypeId:number;
    public fieldtypeId: Fieldtypes = new Fieldtypes();
    public xmldefId:number = null;
    //public xmldefId: Xmldefs = new Xmldefs();
    public numorder:number = null;
    public fieldsize:number = 0;
    public cat:string;
    public esp:string;

    /*prueba*/
    public visibility:number = null;
  
    constructor() {}
  
}